import { CheckCircle, XCircle } from '@phosphor-icons/react';
import { getFormatDate } from '../../../shared/utils/dates.util';
import Text from '../../../components/atoms/Text';
import Heading from '../../../components/atoms/Heading';
import { Deductions } from '../../../@types/Declarations.type';

interface InvoiceDetailProps {
	detail: Deductions;
	isDeductible: boolean;
}

const InvoiceDetail = ({ detail, isDeductible }: InvoiceDetailProps) => {
	// Calculamos el total deducido sumando el tax_amount de todos los productos
	const totalDeducido = detail?.items?.reduce(
		(sum, product) => sum + Math.round(product.tax_amount || 0),
		0,
	);

	return (
		<div className='w-[360px]'>
			<div className='w-full p-6 bg-h-primary-100 rounded-tl-lg rounded-tr-lg rounded-bl-3xl rounded-br-3xl border-b-2 border-h-neutral-90 inline-flex justify-start items-start gap-2'>
				<div className='flex-1 inline-flex flex-col justify-start items-center gap-4'>
					<div className='flex flex-col justify-center items-center gap-2'>
						<Text
							size='body-2'
							weight='regular'
						>
							{detail?.isser_name}
						</Text>
						<Text
							size='body-3'
							weight='light'
						>
							{getFormatDate(detail?.issued_at)}
						</Text>
					</div>
					<Heading
						size='l'
						weight='medium'
					>
						${' '}
						{detail?.total === 0 && detail?.type === 'P'
							? Math.round(detail?.payment_amount || 0).toLocaleString('es-MX')
							: Math.round(detail?.total).toLocaleString('es-MX')}
					</Heading>
					{detail?.total === 0 && detail?.type === 'P' && (
						<Text
							size='body-3'
							weight='light'
						>
							Pago a mensualidades
						</Text>
					)}
				</div>
			</div>

			<div className='w-full px-6 py-8 bg-h-primary-100 rounded-tl-3xl rounded-tr-3xl rounded-bl-lg rounded-br-lg inline-flex flex-col justify-start items-start gap-4 overflow-hidden'>
				<div className='self-stretch flex flex-col justify-center items-start gap-4'>
					{detail?.items?.map((product, index) => (
						<div
							key={index}
							className='w-full flex gap-2'
						>
							<div>
								{product?.is_deductible ? (
									<CheckCircle
										size={16}
										weight='duotone'
										className='text-h-success-50'
									/>
								) : (
									<XCircle
										size={16}
										weight='duotone'
										className='text-h-error-50'
									/>
								)}
							</div>
							<div className='flex justify-between w-full'>
								<div className='flex flex-col justify-start items-start gap-0.5'>
									<Text
										size='body-3'
										weight='light'
									>
										{product?.product_identification_description}
									</Text>
									<Text
										size='mini-1'
										weight='light'
									>
										{product?.reason}
									</Text>
								</div>
								<div className='flex flex-col justify-start items-end gap-0.5'>
									<Text
										size='body-3'
										weight='medium'
									>
										${Math.round(product?.total_amount || 0).toLocaleString('es-MX')}
									</Text>
									{product?.tax_amount && (
										<Text
											size='mini-1'
											weight='light'
										>
											IVA ${Math.round(product?.tax_amount || 0).toLocaleString('es-MX')}
										</Text>
									)}
								</div>
							</div>
						</div>
					))}
				</div>

				{isDeductible && (
					<>
						<div className='self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-h-neutral-90' />

						<div className='w-full flex justify-between items-center'>
							<Text
								size='body-3'
								weight='medium'
							>
								Total deducido de la factura
							</Text>
							<Text
								size='body-3'
								weight='medium'
							>
								${Math.round(totalDeducido).toLocaleString('es-MX')}
							</Text>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default InvoiceDetail;
